/**
 * Copyright (c) 2025 Répét Contributors
 * Licensed under the MIT License
 * See LICENSE file in the project root for full license text
 */

/**
 * ⚠️ STUB TEMPORAIRE V2.0
 * 
 * Ce fichier fournit un stub minimal de ttsEngine pour éviter les erreurs
 * de compilation pendant la phase de transition V1 → V2.
 * 
 * EN V2.0 : Tout le TTS sera géré côté backend (sherpa-onnx)
 * Ce fichier sera supprimé une fois la migration complète.
 */

export interface TTSEngine {
  initialize(): Promise<void>
  speak(config: {
    text: string
    voiceId?: string | null
    rate?: number
    volume?: number
    lineId?: string
  }): void
  pause(): void
  resume(): void
  stop(): void
  isSpeaking(): boolean
  isPaused(): boolean
  setEvents(events: {
    onStart?: () => void
    onEnd?: () => void
    onPause?: () => void
    onResume?: () => void
    onError?: (error: unknown) => void
    onProgress?: (
      progress: number,
      lineId: string,
      currentTime: number,
      audioDuration: number
    ) => void
  }): void
}

// Stub qui ne fait rien
export const ttsEngine: TTSEngine = {
  initialize: async () => {
    console.warn('[ttsEngine STUB] V2.0: initialize() appelé (non implémenté)')
  },
  speak: () => {
    console.warn('[ttsEngine STUB] V2.0: speak() appelé (non implémenté)')
  },
  pause: () => {
    console.warn('[ttsEngine STUB] V2.0: pause() appelé (non implémenté)')
  },
  resume: () => {
    console.warn('[ttsEngine STUB] V2.0: resume() appelé (non implémenté)')
  },
  stop: () => {
    console.warn('[ttsEngine STUB] V2.0: stop() appelé (non implémenté)')
  },
  isSpeaking: () => false,
  isPaused: () => false,
  setEvents: () => {
    console.warn('[ttsEngine STUB] V2.0: setEvents() appelé (non implémenté)')
  },
}
